import { render, staticRenderFns } from "./ListDocumentTypes.vue?vue&type=template&id=9ee8f298&"
import script from "./ListDocumentTypes.vue?vue&type=script&lang=js&"
export * from "./ListDocumentTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ee8f298')) {
      api.createRecord('9ee8f298', component.options)
    } else {
      api.reload('9ee8f298', component.options)
    }
    module.hot.accept("./ListDocumentTypes.vue?vue&type=template&id=9ee8f298&", function () {
      api.rerender('9ee8f298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListDocumentTypes.vue"
export default component.exports